export default "__VITE_ASSET__Cmg5ZHEA__"